import { UcoastEl } from '@/scripts/core/UcoastEl'

export class IngredientsList extends UcoastEl {
	static htmlSelector = 'ingredients-list'

	private ingredients: NodeListOf<HTMLElement>
	private hoverSelect = window.matchMedia(
		'(hover: hover) and (pointer: fine) and (min-width: 750px)'
	)

	constructor() {
		super()

		this.ingredients = this.querySelectorAll<HTMLElement>('.ingredient')
		this.syncHoverMode()
		this.hoverSelect.addEventListener('change', () => this.syncHoverMode())

		this.ingredients.forEach((ingredient) => {
			ingredient.addEventListener('click', () => {
				this.select(ingredient)
			})
			ingredient.addEventListener('mouseenter', () => {
				if (!this.hoverSelect.matches) return
				this.select(ingredient)
			})
			ingredient.querySelector('button[aria-expanded]')?.addEventListener('focus', () => {
				if (!this.hoverSelect.matches) return
				this.select(ingredient)
			})
		})
	}

	private syncHoverMode() {
		this.classList.toggle('is-hover-select', this.hoverSelect.matches)
	}

	private select(ingredient: HTMLElement) {
		this.ingredients.forEach((item) => {
			const selected = item === ingredient
			item.classList.toggle('is-selected', selected)
			item.querySelector('button[aria-expanded]')?.setAttribute('aria-expanded', String(selected))
		})
	}
}
